'use strict';

require('foundation-offcanvas');

require('./utils/jquery-extensions.js');

var $ = require('jquery');

var footerNav = require('./components/footer-nav.js');

var analytics = require('./utils/analytics.js');
var config = require('./utils/config.js');
var menu = require('./ui/menu.js');
var sticky = require('./ui/sticky.js');

var advert = require('./adverts/advert.js');
var skins = require('./adverts/skins.js');

var heightWatcher = require('./watchers/height-watcher.js');
var screenSizeWatcher = require('./watchers/screen-size-watcher.js');

var sourcepoint = require('./utils/sourcepoint.js');

var permutive = require('./utils/permutive.js');
var affiliateLinks = require('./utils/affiliate-links.js');
var admiralTargeting = require('./utils/admiral-targeting.js');
var covatic = require('./utils/covatic.js');
var logger = require('./utils/logger.js');
var localStorageUtils = require('./utils/local-storage-utils.js');
var localStorageConstants = require('./utils/local-storage-constants.js')
var sourcepointConstants = require('./utils/sourcepoint-constants.js');

function initConfig() {
	if (typeof config === 'undefined') {
		window.alert('The tgConfig JSON object must be defined before js loaded.');
	} else {
		console.info('TG config', config);
		analytics.pushToDataLayer(config.data);
	}
}

function loadWatchers() {
	heightWatcher.start();
	screenSizeWatcher.start();
}

function initialiseBasePage() {
	initConfig();

	$(document).foundation();

	loadWatchers();

	menu.init();
	sticky.init();
	sourcepoint.init();
	affiliateLinks.init();
	admiralTargeting.init();
}

function initConsentDependantScripts(config) {
	const consentData = localStorageUtils.getItem(localStorageConstants.consentDataKey);
	if (!consentData) {
		logger.debug('Failed to initialise consent-dependant scripts: No consent data was found.');
		return;
	}

	const { type, consentedVendors } = consentData;

	if (type === 'gdpr' || type === 'usnat') {
		footerNav.init(type);
	}

	permutive.init();
	covatic.init();

	if (consentedVendors.includes(sourcepointConstants.vendorIds.googleAdvertisingProducts)) {
		advert.init(config);
	}
}

module.exports = {
	initBasePage: initialiseBasePage,

	init: initialiseBasePage,

	initGpt: initConsentDependantScripts,

	adverts: {
		skins: skins
	}
};